export default __webpack_public_path__ + "fonts/6895.woff";